import React, { createContext, useContext } from 'react';
import { AppContext } from '@thd-nucleus/app-render';
import { params, shape, arrayOf, string as stringType, number as numberType, bool as boolType, useDataModel, } from '@thd-nucleus/data-sources';
import { useConfigService } from '@thd-nucleus/experience-context';
import { useCustomerInfo } from '../hooks/use-customerInfo';
import { getChannelID } from '../utils/general';
import { useHasBenefitTag } from '../hooks/use-has-benefit-tag';
import { CustomerRole } from '../models/common/customer';
export const LoyaltyMembershipDetailsContext = createContext(null);
export const LoyaltyMembershipDetailsProvider = ({ children, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const { instance } = useContext(AppContext);
    const isB2B = ((_a = instance === null || instance === void 0 ? void 0 : instance.customer) === null || _a === void 0 ? void 0 : _a.type) === 'b2b';
    const { role } = useCustomerInfo();
    const isAdmin = role === CustomerRole.ADMIN;
    const { svocID: customerAccountId, userID: userId } = useCustomerInfo();
    const channelId = getChannelID();
    const query = useDataModel('loyaltyMembershipDetails', {
        variables: { userId, customerAccountId, channelId },
        skip: !isB2B || !userId || !customerAccountId,
        ssr: false,
        context: { withAuth: true },
    });
    const isProHouseUIEnabled = !!useConfigService('ENABLE_PHA_UI');
    const hasProTradeCredit = useHasBenefitTag((_d = (_c = (_b = query === null || query === void 0 ? void 0 : query.data) === null || _b === void 0 ? void 0 : _b.loyaltyMembershipDetails) === null || _c === void 0 ? void 0 : _c.proTiers) === null || _d === void 0 ? void 0 : _d.benefitTags, 'ProTradeCredit');
    const hasProAllowance = useHasBenefitTag((_g = (_f = (_e = query === null || query === void 0 ? void 0 : query.data) === null || _e === void 0 ? void 0 : _e.loyaltyMembershipDetails) === null || _f === void 0 ? void 0 : _f.proTiers) === null || _g === void 0 ? void 0 : _g.benefitTags, 'runnerAllowance');
    const hasPTCOnline = useHasBenefitTag((_k = (_j = (_h = query === null || query === void 0 ? void 0 : query.data) === null || _h === void 0 ? void 0 : _h.loyaltyMembershipDetails) === null || _j === void 0 ? void 0 : _j.proTiers) === null || _k === void 0 ? void 0 : _k.benefitTags, 'PTCOnline');
    return (React.createElement(LoyaltyMembershipDetailsContext.Provider, { value: {
            data: query.data,
            loading: query.loading,
            hasHDWallet: isB2B,
            hasProAllowance,
            hasProTradeCredit: hasProTradeCredit && isProHouseUIEnabled && isAdmin,
            hasPTCOnline,
        } }, children));
};
LoyaltyMembershipDetailsProvider.dataModel = {
    loyaltyMembershipDetails: params({
        userId: stringType().isRequired(),
        customerAccountId: stringType().isRequired(),
        channelId: numberType().isRequired(),
    }).shape({
        customerInfo: shape({
            enrolledInPerksProgram: boolType(),
        }),
        proTiers: shape({
            benefitTags: arrayOf(shape({
                tagName: stringType(),
                value: stringType(),
            })),
        }),
    }),
};
